<div class="link-up-workstation-devices-container">
  <div class="content">
    @if (!devices.length) {
      <div class="device-row">No devices</div>
    } @else {
      @for (device of devices; track device) {
        <div class="device-row">
          <div class="device-name">
            <pdq-icon [icon]="device.type | deviceIcon"></pdq-icon>
            {{ device.name }}
          </div>
          @if (shareable) {
            <div class="device-share">
              Share
              <pdq-checkbox
                [label]="''"
                (onChange)="onShareDevice(device, $event)"
                [checked]="device.share"></pdq-checkbox>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
